import React, { useState } from "react";
import { faEllipsisV } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Draggable } from "react-beautiful-dnd";
import { DataType } from "../../../utils";
import { Card } from "react-bootstrap";
import EditSourceField from "./EditSourceField";

function ActualSourceFieldComponent({
  item,
  index,
  mapped,
  characters,
  setCharacters,
}) {
  const [isOpen, setisOpen] = useState(false);
  return (
    <>
      <Draggable
        key={item.fieldName}
        draggableId={item.fieldName}
        index={index}
      >
        {(provided, snapshot) => (
          <li
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
          >
            <Card className={item.mapped ? "cardCssMapped" : "cardCss"}>
              <div className="ellipsis">
                <FontAwesomeIcon icon={faEllipsisV} size="2x" color="#828282" />
                <FontAwesomeIcon icon={faEllipsisV} size="2x" color="#828282" />
              </div>
              <div className="fieldTitle">
                <span className="fieldText">
                  {item.fieldName[0] == "/"
                    ? item.fieldName.substring(1)
                    : item.fieldName}
                </span>

                {item.mapped ? (
                  <i
                    class="fal fa-check"
                    style={{ fontWeight: "bolder", color: "#228b22" }}
                  ></i>
                ) : null}
              </div>
              <div className="columnTitle">
                <span className="columnText">{item.order}</span>
              </div>
              <div className="sampleData">
                <span className="sampleDataText">
                  Value : <span className="sampleValueText">{item.datum}</span>
                </span>
              </div>
              <div className="dataType">
                <span className="dataTypeText">
                  {DataType[item.type]}
                  <i
                    onClick={() => {
                      setisOpen(true);
                    }}
                    style={{ color: "#307BF6", cursor: "pointer" }}
                    className="far fa-edit ml-2"
                  ></i>
                </span>
              </div>
            </Card>

            <EditSourceField
              fieldHeader={item.fieldName.replace("/", "")}
              dataType={item.type}
              isOpen={isOpen}
              setisOpen={setisOpen}
              characters={characters}
              setCharacters={setCharacters}
              index={item.order}
            />
          </li>
        )}
      </Draggable>
    </>
  );
}

export default ActualSourceFieldComponent;
